/**
 * CommunityAnalytics CMS
 *
 * Application entrypoint
 */

import './bootstrap';

require('bootstrap-sass');
require('bootstrap/js/dist/tab'); // bootstrap 5 tabs

/**
 * Vue axios setup
 */
let csrfToken = document.head.querySelector('meta[name="csrf-token"]');
window.axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken.content;
Vue.prototype.$http = window.axios;

// language bundle
import { i18n } from '@/i18n';

window.App = new Vue({
    el: '#app',
    name: 'App',
    i18n,
    data() {
        return {
            email: '',
            originalLoginMethod: '',
            loginMethod: '',
            apiUrl: '',
        }
    },
    computed: {
        loginMethodButtonText() {
            if (this.loginMethod === this.originalLoginMethod) {
                return this.$t('auth.login_button_alternative');
            } else {
                return this.$t('auth.login_button_original');;
            }
        }
    },
    methods: {
        azureLogin() {
            if (this.$refs.email.reportValidity()) {
                window.location = route('azure.redirect', [this.email]);
            }
        },
        loginToggle() {
            if (this.loginMethod === 'password') {
                this.loginMethod = 'azure';
            } else if (this.loginMethod === 'azure') {
                this.loginMethod = 'password';
            }
        }
    },
    mounted() {
        this.email = window.email;
        this.apiUrl = window.apiUrl;
        this.originalLoginMethod = window.loginMethod;
        this.loginMethod = window.loginMethod;
    }
});

import Vue from 'vue';
 